import React from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, ShieldCheckIcon, CreditCardIcon, UserCheckIcon, TruckIcon, BuildingIcon } from 'lucide-react';
import HeroSection from '../components/Home/HeroSection';
import FeatureCard from '../components/Home/FeatureCard';
import TestimonialCard from '../components/Home/TestimonialCard';
const HomePage = () => {
  return <div className="w-full" data-id="element-1232">
      <HeroSection data-id="element-1233" />
      {/* Features Section */}
      <section className="py-16 bg-white" data-id="element-1234">
        <div className="container mx-auto px-4" data-id="element-1235">
          <div className="text-center mb-16" data-id="element-1236">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-1237">
              How VeriProp Works
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1238">
              We provide a secure, all-in-one platform for Nigerians in the
              diaspora to purchase and manage properties back home.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1239">
            <FeatureCard icon={<BuildingIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1241" />} title="Verified Property Listings" description="Browse through vetted properties with high-quality photos, videos, and virtual 3D tours." data-id="element-1240" />
            <FeatureCard icon={<ShieldCheckIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1243" />} title="Legal Verification" description="Select trusted law firms to verify property documents and handle all legal aspects." data-id="element-1242" />
            <FeatureCard icon={<CreditCardIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1245" />} title="Secure Escrow Payments" description="Transact with confidence using our secure third-party escrow payment system." data-id="element-1244" />
            <FeatureCard icon={<UserCheckIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1247" />} title="Service Marketplace" description="Book cleaning, interior design, and renovation services from verified providers." data-id="element-1246" />
            <FeatureCard icon={<TruckIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1249" />} title="Document & Key Delivery" description="Track the secure delivery of your property documents and keys in real-time." data-id="element-1248" />
            <FeatureCard icon={<SearchIcon className="h-10 w-10 text-[#FF4E00]" data-id="element-1251" />} title="Progress Tracking" description="Monitor every stage of your property transaction through an intuitive dashboard." data-id="element-1250" />
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section className="py-16 bg-gray-50" data-id="element-1252">
        <div className="container mx-auto px-4" data-id="element-1253">
          <div className="text-center mb-16" data-id="element-1254">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-1255">
              Your Journey to Homeownership
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1256">
              A simple, transparent process designed with the diaspora in mind.
            </p>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-1257">
            {[{
            number: 1,
            title: 'Create an Account & Verify Identity',
            description: 'Sign up and complete our secure KYC process designed for diaspora Nigerians.'
          }, {
            number: 2,
            title: 'Browse Verified Properties',
            description: 'Explore our curated listings of pre-verified properties across Nigeria.'
          }, {
            number: 3,
            title: 'Select Legal Verification',
            description: 'Choose from our network of trusted law firms to handle document verification.'
          }, {
            number: 4,
            title: 'Secure Payment via Escrow',
            description: 'Make payments knowing your funds are protected until all conditions are met.'
          }, {
            number: 5,
            title: 'Track Progress & Documentation',
            description: 'Monitor the entire process from purchase to document delivery in real-time.'
          }, {
            number: 6,
            title: 'Access Post-Purchase Services',
            description: 'Easily book property management, renovation, or interior design services.'
          }].map((step, index) => <div key={index} className="flex mb-8 last:mb-0" data-id="element-1258">
                <div className="mr-6" data-id="element-1259">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FF4E00] text-white font-bold text-lg" data-id="element-1260">
                    {step.number}
                  </div>
                  {index < 5 && <div className="h-full w-0.5 bg-[#FF4E00] mx-auto mt-2" data-id="element-1261"></div>}
                </div>
                <div className="pt-2" data-id="element-1262">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1263">
                    {step.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-1264">{step.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-16 bg-white" data-id="element-1265">
        <div className="container mx-auto px-4" data-id="element-1266">
          <div className="text-center mb-16" data-id="element-1267">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-1268">
              What Our Users Say
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1269">
              Hear from Nigerians in the diaspora who have successfully
              purchased property through our platform.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1270">
            <TestimonialCard name="Oluwaseun Adeyemi" location="London, UK" image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80" quote="VeriProp made it possible for me to buy my dream home in Lekki while working in London. The legal verification gave me peace of mind, and the entire process was transparent." data-id="element-1271" />
            <TestimonialCard name="Chioma Okafor" location="Toronto, Canada" image="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80" quote="After years of uncertainty about investing in Nigerian real estate from abroad, I finally found a solution I could trust. The escrow payment system eliminated my fears of fraud." data-id="element-1272" />
            <TestimonialCard name="Emeka Nwosu" location="Houston, USA" image="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80" quote="Not only did I purchase a property seamlessly, but I was also able to furnish it completely through the service marketplace. Everything was ready when I visited Nigeria." data-id="element-1273" />
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#FF4E00] text-white" data-id="element-1274">
        <div className="container mx-auto px-4 text-center" data-id="element-1275">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1276">
            Ready to Own Your Dream Home in Nigeria?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-1277">
            Join thousands of Nigerians in the diaspora who have successfully
            and securely invested in property back home.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1278">
            <Link to="/auth" className="px-8 py-3 bg-white text-[#FF4E00] font-bold rounded-lg hover:bg-gray-100 transition" data-id="element-1279">
              Get Started
            </Link>
            <Link to="/properties" className="px-8 py-3 bg-transparent border-2 border-white font-bold rounded-lg hover:bg-white hover:text-[#FF4E00] transition" data-id="element-1280">
              Browse Properties
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default HomePage;